function move(items, index, direction) {
  const destination = index + direction;
  if (destination < 0 || destination >= items.length) return items;
  const next = [...items];
  const [item] = next.splice(index, 1);
  next.splice(destination, 0, item);
  return next;
}

function RepeaterActions({ label, index, total, onMove, onRemove, allowEmpty = false }) {
  return (
    <div className="admin-repeater-actions">
      <button type="button" onClick={() => onMove(-1)} disabled={index === 0} aria-label={`Move ${label} ${index + 1} earlier`}>Move up</button>
      <button type="button" onClick={() => onMove(1)} disabled={index === total - 1} aria-label={`Move ${label} ${index + 1} later`}>Move down</button>
      <button type="button" className="admin-danger" onClick={onRemove} disabled={!allowEmpty && total === 1} aria-label={`Remove ${label} ${index + 1}`}>Remove</button>
    </div>
  );
}

export function PairRepeater({ legend, help, itemLabel, items, onChange }) {
  const update = (index, field, value) => onChange(items.map((item, itemIndex) => itemIndex === index ? { ...item, [field]: value } : item));
  return (
    <fieldset className="admin-repeater">
      <legend>{legend}</legend>
      {help && <p className="admin-field-help">{help}</p>}
      <div className="admin-repeater-list">
        {items.map((item, index) => (
          <div className="admin-repeater-row" key={`${itemLabel}-${index}`}>
            <div className="admin-repeater-row-heading"><strong>{itemLabel} {index + 1}</strong><RepeaterActions label={itemLabel} index={index} total={items.length} onMove={(direction) => onChange(move(items, index, direction))} onRemove={() => onChange(items.filter((_, itemIndex) => itemIndex !== index))} /></div>
            <label>Title<input value={item.title} onChange={(event) => update(index, "title", event.target.value)} required /></label>
            <label>Description<textarea rows="3" value={item.description} onChange={(event) => update(index, "description", event.target.value)} required /></label>
          </div>
        ))}
      </div>
      <button type="button" className="admin-add-row" onClick={() => onChange([...items, { title: "", description: "" }])}>Add {itemLabel.toLowerCase()}</button>
    </fieldset>
  );
}

export function CategoryRepeater({ items, onChange }) {
  return (
    <fieldset className="admin-repeater admin-category-repeater">
      <legend>Best-fit categories</legend>
      <p className="admin-field-help">These appear as category chips on the Media Kit.</p>
      <div className="admin-repeater-list">
        {items.map((item, index) => (
          <div className="admin-repeater-row compact" key={`category-${index}`}>
            <label>Category {index + 1}<input value={item} onChange={(event) => onChange(items.map((value, itemIndex) => itemIndex === index ? event.target.value : value))} required /></label>
            <RepeaterActions label="Category" index={index} total={items.length} onMove={(direction) => onChange(move(items, index, direction))} onRemove={() => onChange(items.filter((_, itemIndex) => itemIndex !== index))} />
          </div>
        ))}
      </div>
      <button type="button" className="admin-add-row" onClick={() => onChange([...items, ""])}>Add category</button>
    </fieldset>
  );
}

export function CountryRepeater({ items = [], onChange }) {
  const update = (index, field, value) => onChange(items.map((item, itemIndex) => itemIndex === index ? { ...item, [field]: value } : item));
  return (
    <fieldset className="admin-repeater">
      <legend>Top countries</legend>
      <p className="admin-field-help">Use the country code and percentage shown in TikTok Analytics.</p>
      {items.length === 0 && <p className="admin-empty-note">No countries added.</p>}
      <div className="admin-repeater-list">
        {items.map((country, index) => (
          <div className="admin-repeater-row country" key={`country-${index}`}>
            <div className="admin-repeater-row-heading"><strong>Country {index + 1}</strong><RepeaterActions label="Country" index={index} total={items.length} allowEmpty onMove={(direction) => onChange(move(items, index, direction))} onRemove={() => onChange(items.filter((_, itemIndex) => itemIndex !== index))} /></div>
            <label>Code<input value={country.code || ""} maxLength="2" onChange={(event) => update(index, "code", event.target.value.toUpperCase())} placeholder="US" required /></label>
            <label>Name<input value={country.name || ""} onChange={(event) => update(index, "name", event.target.value)} placeholder="United States" required /></label>
            <label>Percentage<input type="number" min="0" max="100" step="0.1" value={country.percent ?? ""} onChange={(event) => update(index, "percent", event.target.value)} required /></label>
          </div>
        ))}
      </div>
      <button type="button" className="admin-add-row" onClick={() => onChange([...items, { code: "", name: "", percent: "" }])}>Add country</button>
    </fieldset>
  );
}
